import { InfoIcon as Info } from "@phosphor-icons/react";
import { isFallbackCategory, legendItems, legendLabel, legendLineStyle } from "@/lib/edgeStyles";

function Swatch({ item }) {
  const s = legendLineStyle(item);
  return (
    <svg width="30" height="10" viewBox="0 0 30 10" aria-hidden="true" className="shrink-0">
      <line x1="1" y1="5" x2="24" y2="5" stroke={s.stroke} strokeWidth={s.strokeWidth} strokeDasharray={s.strokeDasharray} strokeLinecap="round" />
      <polygon points="23,1.5 29,5 23,8.5" fill={s.stroke} />
    </svg>
  );
}

/** Compact legend under the impact diagram: one chip per edge category present in the graph. */
export default function EdgeLegend({ graph }) {
  const items = legendItems(graph);
  if (!items.length) return null;
  return (
    <div className="ml-card px-3 py-2 space-y-1.5" data-testid="impact-edge-legend">
      <div className="flex flex-wrap items-center gap-x-4 gap-y-1.5">
        <span className="ml-mono text-[10px] uppercase tracking-widest text-[var(--ml-text-secondary)]">Edges</span>
        {items.map((item) => (
          <span key={item.category} className="inline-flex items-center gap-1.5 text-xs" title={item.description}
                data-testid={`impact-edge-legend-item-${item.category}`}>
            <Swatch item={item} />
            <span className={isFallbackCategory(item.category) ? "text-[var(--ml-text-secondary)] italic" : ""}>{legendLabel(item)}</span>
            <span className="ml-mono text-[10px] text-[var(--ml-text-secondary)] tabular-nums" data-testid={`impact-edge-legend-count-${item.category}`}>{item.count}</span>
          </span>
        ))}
      </div>
      <p className="text-[11px] text-[var(--ml-text-secondary)] flex items-start gap-1.5" data-testid="impact-edge-legend-note">
        <Info size={12} className="shrink-0 mt-0.5" />
        <span>{graph.legend.note} Thick = mutation, dashed = logic / membership, solid = data flow.</span>
      </p>
    </div>
  );
}
